export const INITIAL_HOVERED_ROW_INDEX = -1;
export const HOVERED_ROW_CLASSNAME = "hovered";
export const CAN_BE_HOVERED_ROW_CLASSNAME = "can-be-hovered";
